module.exports = __webpack_public_path__ + "img/backIcon.01291670.svg";